import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/peg_solitaire.json";
import fr from "@/locales/fr/puzzle-types/peg_solitaire.json";

export const PEG_SOLITAIRE_NS = "puzzle-types/peg_solitaire";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerPegSolitaireTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", PEG_SOLITAIRE_NS))
    i18n.addResourceBundle("en", PEG_SOLITAIRE_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", PEG_SOLITAIRE_NS))
    i18n.addResourceBundle("fr", PEG_SOLITAIRE_NS, fr, true, true);
}
